import * as Tooltip from '@radix-ui/react-tooltip';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';


export const TooltipComponent = ({content, link, children, side='top', activateOnHover=true}) => {
  const [open, setOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      // Add event listener for resize
      window.addEventListener('resize', handleResize);

      // Clean up by removing the event listener
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    return(
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root onOpenChange={(open)=> !!activateOnHover && setOpen(open)} open={open}>
        <Tooltip.Trigger asChild onClick={()=>{windowWidth<990 && setOpen(!open)}} >
          {children}
        </Tooltip.Trigger>
          <Tooltip.Content
            side={side}
          className={clsx(
            "inline-flex items-center rounded-md px-4 py-2.5 bg-white border relative",
          )}
          style={{
            boxShadow: '0px 2px 6px 0px #63636333'
          }}>
          <Tooltip.Arrow className="fill-current text-white " />
          <div className="block text-xs leading-none text-[#282828] flex flex-col gap-2">
           {content}
           {link !== undefined && <a href={link} className='text-[#D4002A] underline  underline-[#D4002A]'>Learn more</a>}
          </div>
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
    )
}